import React, { Component } from 'react'
import CommonTableModule from './../CommonTable/CommonTableModule';
import { Card, Alert, Spinner, Badge, Button, Form, Row, Col } from "react-bootstrap";
import axios from "axios";
import { DateTimeFormat } from '../DateFormat/DateTimeFormat';
import CommonLoader from '../loaderComponent/CommonLoader';
import { hasPermission } from '../../utils/usePermission';

export default class AdvancePaymentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      advancePayments: [],
      employeesData: [],
      loading: true,
      hasError: false,
      errMsg: "",
      employee: '',
      startDate: '',
      endDate: '',
      filtersApplied: false
    };
  }

  async componentDidMount() {
    this.setState({ loading: true })
    this.fetchEmployeeData();
    this.fetchAdvancePayments(); // Initial fetch without filters
  }
  fetchAdvancePayments = async (filters = {}) => {
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }

    const headers = { Authorization: `Bearer ${token}` };

    // Build query parameters
    const params = {};
    if (filters.employee && filters.employee !== 'all') {
      params.employee = filters.employee;
    }
    if (filters.startDate) {
      params.startDate = filters.startDate;
    }
    if (filters.endDate) {
      params.endDate = filters.endDate;
    }

    try {
      const response = await axios.get('/advancePayment/list', {
        headers,
        params
      });

      // Check if response has data array or message
      if (response.data && Array.isArray(response.data)) {
        this.setState({
          advancePayments: response.data,
          hasError: false,
          filtersApplied: Object.keys(filters).length > 0
        });
      } else if (response.data && response.data.message) {
        // No records found case
        this.setState({
          advancePayments: [],
          hasError: false,
          filtersApplied: Object.keys(filters).length > 0
        });
      }
    } catch (error) {
      console.error("Error fetching advance payment:", error);
      let errorMessage = "No records to display.";

      if (error.response && error.response.status === 403) {
        errorMessage = "Access Denied! Admin privileges required.";
      } else if (error.response && error.response.status === 400 || error.response.status === 200) {
        errorMessage = error.response.data.message || "No advance payments found.";
        this.setState({
          advancePayments: [],
          hasError: true,
          errMsg: errorMessage
        });
        return;
      }

      this.setState({
        hasError: true,
        errMsg: errorMessage,
        advancePayments: []
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  fetchEmployeeData = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      this.setState({ hasError: true, errMsg: "Unauthorized! Please log in.", loading: false });
      return;
    }

    const headers = { Authorization: `Bearer ${token}` };
    try {
      const response = await axios.get('/users', { headers });
      this.setState({ employeesData: response?.data });
    } catch (error) {
      console.error("Error fetching employees:", error);
      // Don't block the entire page if employee list fails
    }
  }

  handleApplyFilter = () => {
    this.setState({ loading: true });

    const filters = {
      employee: this.state.employee,
      startDate: this.state.startDate,
      endDate: this.state.endDate
    };

    this.fetchAdvancePayments(filters);
  }

  handleResetFilter = () => {
    this.setState({
      employee: '',
      startDate: '',
      endDate: '',
      loading: true
    }, () => {
      // Fetch all records without filters
      this.fetchAdvancePayments();
    });
  }

  handleFilterChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleAddAdvancePayment = () => {
    this.props.history.push('/advance-pay-add')
  }

  render() {
    const columns = [
      { key: "id", label: "S.No" },
      {
        key: "id",
        label: "Employee Id",
      },
      {
        key: "user",
        label: "Full Name",
        render: (row) => row?.fullName || "N/A"
      },
      { key: "amount", label: "Amount" },
      { key: "month", label: "Month" },
      { key: "year", label: "Year" },
      { key: "description", label: "Description" },
      { key: "type", label: "Type" },
      {
        key: "dateOfPayment",
        label: "Date",
        render: (value) => DateTimeFormat(value)
      },
    ];

    return (
      <div className="container-fluid pt-4">
        <CommonLoader isLoading={this.state.loading}>
          {hasPermission('M12S1') && (
            <div className='add-role mb-3'>
              <Button
                variant="primary"
                className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button"
                onClick={this.handleAddAdvancePayment}
              >
                <i className="fa fa-plus-circle"></i> Add Advance Pay
              </Button>
            </div>
          )}

          <Card className="mb-3">
            <Card.Header>
              <b>Advance Payment List</b>
              {this.state.filtersApplied && (
                <Badge bg="info" className="ms-2">
                  Filter Applied
                </Badge>
              )}
            </Card.Header>
            <Card.Body>
              <div className='pnakaj'>
                <Row className="align-items-end mb-3">
                  <Col xs={12} md={3}>
                    <Form.Group>
                      <Form.Label>Employee</Form.Label>
                      <Form.Control
                        as="select"
                        className="form-select"
                        name="employee"
                        value={this.state.employee}
                        onChange={this.handleFilterChange}
                      >
                        <option value="">All Employees</option>
                        {this.state.employeesData.map((emp) => (
                          <option key={emp.id} value={emp.id}>
                            {emp.fullName} (ID: {emp.id})
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={2}>
                    <Form.Group>
                      <Form.Label>Start Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="startDate"
                        value={this.state.startDate}
                        onChange={this.handleFilterChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={2}>
                    <Form.Group>
                      <Form.Label>End Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="endDate"
                        value={this.state.endDate}
                        onChange={this.handleFilterChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} md={5} className="d-flex gap-2">
                    <Button
                      className="button-filter"
                      variant="primary"
                      onClick={this.handleApplyFilter}
                      disabled={this.state.loading}
                    >
                      <i className="fa fa-search me-1"></i> Apply Filter
                    </Button>

                    <Button
                      className="button-filter"
                      variant="outline-secondary"
                      onClick={this.handleResetFilter}
                      disabled={this.state.loading}
                    >
                      <i className="fa fa-refresh me-1"></i> Reset
                    </Button>

                    {hasPermission('M11B5') && (
                      <Button
                        className="button-filter"
                        variant="outline-info"
                        onClick={() => window.print()}
                      >
                        <i className="fa fa-print me-1"></i> Print
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>

              {this.state.hasError ? (
                <Alert variant="info" className="text-center">
                  {this.state.errMsg}
                </Alert>
              ) : (
                <>
                  {this.state.advancePayments.length === 0 ? (
                    <Alert variant="warning" className="text-center">
                      No advance payments found
                    </Alert>
                  ) : (
                    <>
                      <div className="mb-3">
                        <Badge bg="light" text="dark" className="me-2">
                          Total Records: {this.state.advancePayments.length}
                        </Badge>
                        {this.state.startDate && (
                          <Badge bg="light" text="dark" className="me-2">
                            From: {this.state.startDate}
                          </Badge>
                        )}
                        {this.state.endDate && (
                          <Badge bg="light" text="dark">
                            To: {this.state.endDate}
                          </Badge>
                        )}
                      </div>
                      <CommonTableModule
                        columns={columns}
                        data={this.state.advancePayments}
                      />
                    </>
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </CommonLoader>
      </div>
    )
  }
}